import React, { useState } from 'react';
import { ChevronDown, Folder, FolderOpen } from 'lucide-react';

const NONE = 'Sin carpeta';

const FolderSection = ({ name, items, renderCard, forceOpen }) => {
  const [open, setOpen] = useState(false);
  const isOpen = forceOpen || open;
  const Icon = isOpen ? FolderOpen : Folder;
  return (
    <section className="rounded-xl border bg-card" data-testid={`resource-folder-${name}`}>
      <button type="button" onClick={() => setOpen((o) => !o)} className="w-full flex items-center gap-2 px-4 py-3 text-left hover:bg-muted/40 rounded-xl transition-colors" data-testid={`resource-folder-toggle-${name}`}>
        <ChevronDown className={`w-4 h-4 text-muted-foreground transition-transform ${isOpen ? '' : '-rotate-90'}`} />
        <Icon className="w-5 h-5 text-amber-500" />
        <span className="font-semibold text-sm flex-1">{name}</span>
        <span className="text-xs text-muted-foreground">{items.length}</span>
      </button>
      {isOpen && <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 px-4 pb-4">{items.map(renderCard)}</div>}
    </section>
  );
};

export const ResourceFolders = ({ items, renderCard, forceOpen, groupBy = (r) => r.categoria }) => {
  const groups = {};
  items.forEach((r) => { const k = groupBy(r) || NONE; (groups[k] = groups[k] || []).push(r); });
  const names = Object.keys(groups).sort((a, b) => (a === NONE) - (b === NONE) || a.localeCompare(b, 'es'));
  names.forEach((n) => groups[n].sort((a, b) => (a.titulo || '').localeCompare(b.titulo || '', 'es')));
  return (
    <div className="space-y-2" data-testid="resources-folders">
      {names.map((n) => <FolderSection key={n} name={n} items={groups[n]} renderCard={renderCard} forceOpen={forceOpen} />)}
    </div>
  );
};
